import React from 'react';
import FormControl from '../../components/FormControl';
import { ErrorToastComponent as ErrorToast } from '../../components/Toasts';
import { postData } from '../../helper';
import { BasicCard } from '../../components/Card';

class AddWarehousePage extends React.Component {
    constructor(props) {
        super();
        this.submitHandler = this.submitHandler.bind(this);
        this.pageContent = this.pageContent.bind(this);
        const self = this;
        this.state = {
            err_message: null,
            form: {
                onSubmit: self.submitHandler
            },
            fields: { 
                warehouse_name: {
                    label: 'Warehouse Name',
                    type: 'text',
                    placeholder: 'Name of your warehouse.',
                    value: '',
                    required: true,
                    onChange: self.onChangeHandler
                },
                address_line_1: {
                    label: 'Address Line 1',
                    type: 'text',
                    placeholder: 'Address Line 1',
                    value: '',
                    required: true,
                    onChange: self.onChangeHandler
                },
                address_line_2: {
                    label: 'Address Line 2',
                    type: 'text',
                    placeholder: 'Address Line 2',
                    value: '',
                    required: true,
                    onChange: self.onChangeHandler
                },
                pincode: {
                    label: 'Pincode',
                    type: 'text',
                    placeholder: 'Pincode',
                    value: '',
                    required: true,
                    onChange: self.onChangeHandler
                },
                landmark: {
                    label: 'Landmark',
                    type: 'text',
                    placeholder: 'Landmark',
                    value: '',
                    required: true,
                    onChange: self.onChangeHandler
                },
                city: {
                    type: 'city',
                    placeholder: 'City',
                    value: '',
                    required: true,
                    onChange: self.onChangeHandler
                },
                state: {
                    type: 'state',
                    placeholder: 'State',
                    value: '',
                    required: true,
                    onChange: self.onChangeHandler
                },
                country: {
                    type: 'country',
                    placeholder: 'Country',
                    value: 'IN',
                    required: true,
                    onChange: self.onChangeHandler
                },
                mobile_number: {
                    type: 'text',
                    placeholder: 'Contact mobile number',
                    value: '',
                    required: true,
                    onChange: self.onChangeHandler
                },
                contact_person: {
                    type: 'text',
                    placeholder: 'Contact person',
                    value: '',
                    required: true,
                    onChange: self.onChangeHandler
                },
                create_button: {
                    type: 'button',
                    label: 'Add Warehouse',
                    btn_type: 'submit'
                }
            }
        };
    }

    async componentDidMount() {
        try {

        } catch(err) {
            throw new Error(err.message);
        }
    }

    onChangeHandler = (e) => {
        try {
            const fields = this.state.fields;
            fields[e.target.name].value = e.target.value;
            this.setState({fields: fields});
        } catch(err) {
            throw new Error(err.message);
        }
    }

    async submitHandler(payload) {
        try {

            const response = await postData('/warehouses', payload);
            if(response.error && response.error.message) {
                this.setState({err_message: response.error.message});
            } else {
                window.location.href = `/inventory?screen=warehouselisting`;
                return;
            }

        } catch(err) {
            return new Error(err.message);
        }
    }

    pageContent() {
        try {
            return (
                <>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className="card o-hidden border-0">
                                    <div className="card-body p-0">
                                        <div className="p-5">
                                            <FormControl fields={this.state.fields} config={this.state.form}/>
                                            <ErrorToast message={this.state.err_message}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )
        } catch(err) {
            throw new Error(err.message);
        }
    }

    render() {
        return (
            <>
                <div class='container'>
                    <BasicCard title='New Warehouse' content={this.pageContent(this.props)}/>
                </div>
            </>
        );
    }
}

export default AddWarehousePage;